const classes = {
  pageTitle: {
    color: 'primary.main',
    fontSize: '32px',
    fontWeight: 700,
    marginRight: { md: 1, lg: 0 },
  },
  optionsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 3,
    justifyContent: 'center',
  },
  loaderContainer: {
    display: 'flex',
    height: '65px',
    justifyContent: 'center',
    pt: 1,
  },
  infiniteScroll: {
    display: 'flex',
    maxHeight: '100%',
  },
  dataGrid: {
    borderWidth: '0px',
    '& .inactive-row': {
      backgroundColor: '#E5E5E5 !important',
    },
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: { xs: 3, sm: 6 },
    height: 'auto',
    paddingX: 7,
    paddingY: 5,
  },
  topContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: 3, md: 0 },
    justifyContent: 'space-between',
  },
  filtersButton: {
    fontSize: '11px',
    fontWeight: 600,
    gap: 0,
    lineHeight: '10px',
    minWidth: '135px',
    width: '135px',
  },
  seeDetailsButton: {
    color: 'primary',
    height: 'auto',
    minWidth: 'auto',
    p: 0,
    textTransform: 'none',
  },
  deleteButton: {
    color: '#F03A47',
    height: 'auto',
    minWidth: 'auto',
    p: 0,
    textTransform: 'none',
  },
};

export default classes;
